export const Form = {
  parts: ['errorText', 'helperText'],
  baseStyle: {
    fontFamily: 'body',
    helperText: {
      fontSize: 'xs',
    },
    errorText: {
      fontSize: 'xs',
    },
  },
};
